import {ChangeDetectorRef, Component, inject, OnInit} from '@angular/core';
import {AdminService} from '../../admin/services/admin.services';
import {ActivatedRoute} from '@angular/router';
import {DatePipe, DOCUMENT, NgIf, SlicePipe, TitleCasePipe, UpperCasePipe} from '@angular/common';
import {updateSeo} from '../../shared/seo/seo';

@Component({
  selector: 'app-product-registration-card',
  imports: [
    DatePipe,
    SlicePipe,
    NgIf,
    UpperCasePipe,
    TitleCasePipe
  ],
  templateUrl: './product-registration-card.html',
  styleUrl: './product-registration-card.scss',
})
export class ProductRegistrationCard implements OnInit {
  private adminService = inject(AdminService)
  private route = inject(ActivatedRoute)
  private cdr  = inject(ChangeDetectorRef)
  private readonly document = inject(DOCUMENT);
  ownerDetails:any;
  ngOnInit() {
    updateSeo(
      this.document,
      'Product Registration | VENTORA',
      'Internal product registration page for the VENTORA store.',
      undefined,
      '/product-registration',
      undefined,
      'noindex,follow,max-image-preview:large,max-snippet:-1,max-video-preview:-1',
    );
    this.getOwner();
  }

  // 1. Ensure this is defined globally in the class
  romanMonths = ['I', 'II', 'III', 'IV', 'V', 'VI', 'VII', 'VIII', 'IX', 'X', 'XI', 'XII'];

  get romanMonth(): string {
    // Use a temporary variable to check the value
    const dateVal = this.ownerDetails?.createdAt;

    if (!dateVal) return '—'; // Return a dash so you can see if it's hitting the null check

    const d = new Date(dateVal);
    // Check if the date is valid
    if (isNaN(d.getTime())) return '?';

    return this.romanMonths[d.getMonth()];
  }
  getOwner(){
    const param:any = this.route.snapshot.paramMap.get('owner');
    this.adminService.getOrdersByOrderConfigId(param).subscribe({
      next: (details) => {
        this.ownerDetails = details;
        this.cdr.markForCheck();
      }
    })
  }



}
